import { StateCreator } from 'zustand';

import { AuthenticationData, AuthenticationSlice } from './types';

const initialState: AuthenticationData = {
  email: '',
  transactionId: '',
  signUpToken: '',
  individualId: '',
  firstName: '',
  lastName: '',
  password: '',
  confirmPassword: '',
  phoneNumber: '',
  referralCode: '',
  requiresName: false,
  isContextSwitch: false,
  cognitoUser: {
    attributes: {
      email: '',
      'custom:individual_id': '',
      phone_number: '',
    },
    challengeName: '',
    challengeParam: {
      CODE_DELIVERY_DELIVERY_MEDIUM: '',
      CODE_DELIVERY_DESTINATION: '',
    },
  },
};

const authenticationSlice: StateCreator<AuthenticationSlice> = (set) => ({
  authenticationData: initialState,
  setAuthenticationData(authenticationData) {
    set((state) => ({
      authenticationData: { ...state.authenticationData, ...authenticationData },
    }));
  },

  resetAuthenticationData() {
    set({ authenticationData: initialState });
  },
});

export default authenticationSlice;
